/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { Manageable, ManageableInterface } from "../Manageable";

const _abi = [
  {
    inputs: [],
    name: "ManagerDidNotChange",
    type: "error",
  },
  {
    inputs: [],
    name: "ManagerIsZero",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyManager",
    type: "error",
  },
  {
    inputs: [],
    name: "OnlyOwnerOrManager",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "manager",
        type: "address",
      },
    ],
    name: "ManagerChanged",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_manager",
        type: "address",
      },
    ],
    name: "changeManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "manager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class Manageable__factory {
  static readonly abi = _abi;
  static createInterface(): ManageableInterface {
    return new utils.Interface(_abi) as ManageableInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Manageable {
    return new Contract(address, _abi, signerOrProvider) as Manageable;
  }
}
